const TERMS_AND_CONDITIONS	= "https://www.appfielder.com/terms-of-service/";
const POLICY	= "https://www.appfielder.com/policy";

const STATIC_LINK = {
	tearmsAndConditions:TERMS_AND_CONDITIONS,
	policy:POLICY
};

export default STATIC_LINK;
